import React, { useState, useEffect } from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import { ListSubheader } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import Chip from "@mui/material/Chip";
import CancelIcon from "@mui/icons-material/Cancel";

const MultiSelectCountry = (props) => {
  const customerData = props?.countryList;
  const geoIdList = props?.geoIdList;

  let geoIdArray = [];
  let geoIDLength = 0;

  if (geoIdList == null || geoIdList == "") {
    //if(roleid=== 1 || roleid=== 3 || roleid=== 5){
     // geoIdArray = customerData.map((item) => item.countryID);
    //}
    
    if (geoIdArray.length > 2) geoIDLength = geoIdArray.length - 2;
  } else {
    geoIdArray = geoIdList.split(",");
    if (geoIdArray.length > 2) geoIDLength = geoIdArray.length - 2;
  }

  const customers = [...new Set(customerData.map((item) => item.countryName))];
  const [customerName, setCustomerName] = useState([]);
  const [displayItem, setDisplayItem] = React.useState(customerData?.length);
  const [searchText, setSearchText] = React.useState("");
  const [namesData, setNamesData] = React.useState([]);
  const textInput = React.useRef(null);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectAll, setSelectAll] = useState(
    geoIdArray.length == customerData.length ? true : false
  );

  useEffect(() => {
    customerData.map((item) => {
      geoIdArray.map((geoId) => {
        if (item.countryID == geoId) {
          setCustomerName((prevStateArray) => [
            ...prevStateArray,
            item.countryName,
          ]);
        }
      });
    });
  }, [geoIdList]);

  const handleChange = (e, name) => {
    let items = [...customerName];

    if (e.target.checked) items.push(name);
    else {
      var index = items.indexOf(name);
      items.splice(index, 1);
    }

    setCustomerName(items);
    props.sendDataToParent(items);
    let itemcount = items.length;
    if (itemcount > 2) setDisplayItem(itemcount - 2);
    else setDisplayItem(itemcount);
    if (itemcount == 0) setSelectAll(false);
    if (itemcount == customerData.length) setSelectAll(true);
    else setSelectAll(false);
  };

  // const handleDelete = (e, value) => {
  //   e.preventDefault();
  //   const updatedCustomerName=customerName.filter((name) => name !== value);
  //   setCustomerName(updatedCustomerName);
  //   let count = displayItem - 1;
  //   if (count == 0) count = "";
  //   setDisplayItem(count);
  // };

  const handleDelete = (e, value) => {
    e.preventDefault();
    const updatedCustomerName = customerName.filter((name) => name !== value);
    //setCustomerName(updatedCustomerName);
    setCustomerName((prevNames)=>{
      const updatedNames = prevNames.filter((name) => name !== value);
      props.sendDataToParent(updatedNames);
      return updatedNames;
    })
  
    let count = updatedCustomerName.length > 2 ? updatedCustomerName.length - 2 : updatedCustomerName.length;
    setDisplayItem(count);
  
    if (updatedCustomerName.length === 0) {
      setSelectAll(false);
    }
  };


  useEffect(() => {
    // Clear search text value
    setNamesData(customers);
  }, [customerData]);

  const handleInputChange = (value) => {
    setSearchText(value);
  };

  // const handleSelectAll = () => {
  //   if (!selectAll) {
  //     setSelectedOptions(namesData);

  //     setCustomerName(customers);
  //     let itemcount = namesData.length;
  //     if (itemcount > 2) setDisplayItem(itemcount - 2);
  //     else setDisplayItem(itemcount);
  //     props.sendDataToParent(customers);
  //   } else {
  //     setSelectedOptions([]);
  //     setCustomerName([]);
  //     //props.sendDataToParent([]);
  //   }

  //   setSelectAll(!selectAll);
  // };

  useEffect(() => {
    let itemcount = selectedOptions.length;
    if (itemcount > 2) setDisplayItem(itemcount - 2);
    else if (itemcount == 0 && geoIDLength > 0) setDisplayItem(geoIDLength);
    else setDisplayItem(0);
  }, [selectedOptions]);

  const handleSelectAll = () => {
    if (!selectAll) {
      if (searchText) {
        let val = customers.filter((name) =>
          name.toLowerCase().includes(searchText.toLowerCase())
        );
        let item = [...customerName, ...val];
        const distinctArray = [...new Set(item)];
        setCustomerName(distinctArray);
        let itemcount = distinctArray.length;
        if (itemcount > 2) setDisplayItem(itemcount - 2);
        else setDisplayItem(itemcount);
      } else {
        setCustomerName(customers);
        let itemcount = customers.length;
        if (itemcount > 2) setDisplayItem(itemcount - 2);
        else setDisplayItem(itemcount);
      }
    } else {
      if (searchText) {
        let val = customers.filter((name) =>
          name.toLowerCase().includes(searchText.toLowerCase())
        );
        let item = [...customerName];
        item = item.filter((name) => !val.includes(name));
        const distinctArray = [...new Set(item)];
        setCustomerName(distinctArray);

        let itemcount = distinctArray.length;
        if (itemcount > 2) setDisplayItem(itemcount - 2);
        else setDisplayItem(itemcount);
      } else {
        setCustomerName([]);
        props.sendDataToParent([]);
      }
    }
    setSelectAll(!selectAll);
  };

  useEffect(() => {
    let item = [...namesData];
    item = item.filter((name) => !customerName.includes(name));
    if (item.length == 0) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  }, [namesData]);

  useEffect(() => {
    //use a debounce to delay the search input key entry
    const delayDebounceFn = setTimeout(() => {
      if (searchText) {
        //filter options state using search text provided
        setNamesData((prevVal) => {
          let val = namesData.filter((name) =>
            name.toLowerCase().includes(searchText.toLowerCase())
          );

          return val;
        });
      } else {
        setSearchText();
        setNamesData(customers);
      }

      //set focus on search text input field on load. setTimeOut is added as textInput is not immediately available
      setTimeout(() => {
        if (textInput.current) textInput.current.focus();
      }, 100);
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchText]);

  useEffect(() => {
    const uniqueNames=[...new Set(customerName)];
    if(uniqueNames.length!==customerName.length){
      setCustomerName(uniqueNames);
    }
    props.sendDataToParent([...new Set(customerName)]);
  }, [customerName]);


  return (
    <div>
      <FormControl sx={{ width: 260,mt:2 }}>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          //fullWidth
          sx={{ width: 260, height: "38px !important", mt: "-10px !important" }}
          value={customerName}
          //onChange={handleChange}
          size="small"
          input={<OutlinedInput label="MultiSelect" />}
          renderValue={(selected) => (
            <Box
              sx={{
                display: "flex",
                gap: 0.5,
              }}
            >
              {selected.map((value, index) => (
                <div>
                  {index < 2 ? (
                    <Chip
                      key={index}
                      label={value}
                      clickable
                      //color="primary"
                      style={{backgroundColor:"#BFD4E1",color:"#000000"}}
                      variant="contained"
                      deleteIcon={
                        <CancelIcon
                        style={{color:"#005587"}}
                          onMouseDown={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                          }}
                        />
                      }
                      onDelete={(e) => handleDelete(e, value)}
                    />
                  ) : (
                    <div>{index < 3 ? <div>+ {displayItem}</div> : null}</div>
                  )}
                </div>
              ))}
            </Box>
          )}
        >
          <MenuItem onClick={handleSelectAll}>
            <Checkbox checked={selectAll} />
            <ListItemText primary="Select All" />
          </MenuItem>
          <ListSubheader>
            <TextField
              size="small"
              inputRef={textInput}
              placeholder=""
              //fullWidth
              value={searchText}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                endAdornment: (
                  /*close icon to clear the search text*/
                  <InputAdornment position="end">
                    <IconButton onClick={() => setSearchText("")}>
                      <CloseIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              onChange={(e) => handleInputChange(e.target.value)}
              onKeyDown={(e) => {
                if (e.key !== "Escape") {
                  // Prevents autoselecting item while typing (default Select behaviour)
                  e.stopPropagation();
                }
              }}
            />
          </ListSubheader>
          {namesData?.map((name, index) => (
            <MenuItem key={index + name} value={name}>
              {selectAll ? (
                <Checkbox
                  onChange={(e) => handleChange(e, name)}
                  checked={customerName.some((o) => o === name)}
                />
              ) : (
                <Checkbox
                  onChange={(e) => handleChange(e, name)}
                  checked={customerName.indexOf(name) > -1}
                />
              )}

              <ListItemText primary={name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default MultiSelectCountry;
